<template>
  <div>
    <div class="feet">
      <!--下载模板-->
      <el-button size="small" type="primary" @click="downloadFile(1)">
        {{ $t('basicData.DownloadTheTemplate') }}
      </el-button>

      <!--批量导入-->
      <upload-excel
        v-permit:remove="'btn:finance:basicData:quotationManagement:edit'"
        class="feet-btn"
        :but-name="BulkImport"
        :on-success="importLogistics"
      />

      <div v-if="importType === 1">
        <!--普通规则下载报价-->
        <el-button size="small" type="primary" @click="downloadFile(2)">
          {{ $t('basicData.DownloadTheQuote') }}
        </el-button>
      </div>
      <div v-if="importType===2">
        <!--其它规则下载报价-->
        <el-button size="small" type="primary" @click="downloadFile(3)">
          {{ $t('basicData.DownloadTheQuote') }}
        </el-button>
      </div>
    </div>

    <el-dialog
      :append-to-body="true"
      :title="$t('basicData.tips')"
      :visible.sync="dialogVisible"
      width="400"
    >
      <div v-for="(item, ind) in errData" :key="ind" style="color:#f00;margin-bottom: 8px;">{{ item }}</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">{{ $t('basicData.determine') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { downloadTemplate, importQuotation } from './downloadFile';

export default {
  name: 'ImportDownload',
  components: {
    'upload-excel': () => import('@/components/UploadExcel/index')
  },
  props: {
    // 表单数据
    tableData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    // 普通规则数据
    tableDataObj: {
      type: Object,
      default: () => {
        return {};
      }
    },
    // 其他规则数据
    otherRulesRawData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 普通费用
    expenseTypeList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 特殊费用
    specialFeeList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 保险类型
    insuranceTypeList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 模板类型 1: 普通规则 2: 其他规则
    importType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      BulkImport: this.$t('basicData.BulkImport'), // 批量导入
      MultiPartitionImport: this.$t('basicData.MultiPartitionImport'), // 批量导入
      errData: [],
      dialogVisible: false
    };
  },
  methods: {
    // 导出数据处理
    exportData() {
      const collectFeesList = [];
      Object.values(this.tableDataObj).forEach(data => {
        if (data) {
          collectFeesList.push(...data);
        }
      });
      const formData = this.tableData.formData;

      const collectFeesArr = collectFeesList.map(item => {
        const subregion = this.tableData.subregionList.find(list =>
          item.partitionAffiliateId === list.id
        );
        return {
          ...item,
          name: formData.name,
          offerType: formData.offerType,
          billType: formData.billType,
          cargoType: formData.cargoType,
          expressType: formData.expressType,
          providerInfoName: formData.providerInfoName,
          siteName: formData.siteName,
          partitionName: formData.partitionName,
          postalCode: subregion?.postalCode || ''
        };
      });
      console.log(collectFeesList, 'collectFeesList');
      return { data: collectFeesArr };
    },
    // 下载模板\下载报价
    downloadFile(type) {
      try {
        const { formData, subregionList, modelList } = this.tableData;
        const { businessType } = formData;
        if (formData.businessType === null) {
          this.$message.warning(this.$t('basicData.PleaseSelectTheBusinessTypeFirst'));
          return;
        }
        if (businessType !== 8 && subregionList.length === 0) {
          this.$message.warning(this.$t('basicData.PleaseChooseAPartitionSchemeFirst'));
          return;
        }
        if (businessType === 8 && modelList.length === 0) {
          this.$message.warning(this.$t('basicData.CannotBeEmpty'));
          return;
        }

        // type： 1: 下载模板 2: 下载报价 3:下载其它规则报价
        // importType： 1: 普通规则 2: 其他规则
        const collectFeesArr = this.importType === 1 ? this.exportData().data : this.otherRulesRawData;
        console.log(collectFeesArr, '规则数据');
        downloadTemplate(
          type,
          this.importType,
          formData,
          subregionList,
          modelList,
          this.expenseTypeList,
          this.specialFeeList,
          this.insuranceTypeList,
          collectFeesArr
        );
      } catch (error) {
        console.log(error);
      }
    },
    // 批量导入报价
    importLogistics(arr) {
      console.log(arr, '批量导入数据');
      this.errData = [];
      let otherData = [];
      const { formData } = this.tableData;
      try {
        const { data } = importQuotation(this.importType, formData, arr);
        if (!data || data.length === 0) {
          return;
        }
        console.log(data, '解析后数据-sheet_data');
        // 数据校验
        const row = this.$t('basicData.row');
        const line = this.$t('basicData.line');
        if (this.importType === 1) {
          data.forEach((item, ind) => {
            const { startWeight, endWeight, startCases, endCases } = item;
            // 包裹开始数量不能大于包裹结束数量
            let start;
            if (startWeight !== undefined && startWeight !== null && startWeight !== '') {
              start = parseFloat(startWeight); // 如果startWeight存在，无论其值如何，都使用它
            } else {
              start = Number(startCases); // 如果startWeight不存在，使用startCases
            }
            let end;
            if (endWeight !== undefined && endWeight !== null && endWeight !== '') {
              end = parseFloat(endWeight);
            } else {
              end = Number(endCases);
            }
            console.log(start, end);
            if (start >= end) {
              this.errData.push(`${row}${ind + 1}${line},${this.$t('basicData.TheStartValueCannotBeGreaterThanTheEndValue')}`);
            }
            if (isNaN(start) || isNaN(end)) {
              this.errData.push(`${row}${ind + 1}${line},${this.$t('receivablePayable.dataError')}`);
            }
          });
        } else {
          // 特殊规则校验，同一分区下费用不可重复
          const seen = new Set();
          const idMap = new Map();
          // 预处理建立分区映射
          data.forEach((item, index) => {
            const key = item.partitionAffiliateId;
            if (!idMap.has(key)) idMap.set(key, new Map());
            const feeMap = idMap.get(key);

            if (feeMap.has(item.feeTypeCode)) {
              const prevIndex = feeMap.get(item.feeTypeCode);
              const linePair = [prevIndex + 1, index + 1].sort().join('与');
              if (!seen.has(linePair)) {
                seen.add(linePair);
                this.errData.push(
                  `${this.$t('basicData.row')}${linePair}` +
                  `${this.$t('basicData.line')}` +
                  this.$t('basicData.TheCostTypeTheSamePartitionCannotBeTheSame')
                );
              }
            } else {
              feeMap.set(item.feeTypeCode, index);
            }
          });

          // 特殊规则数据解析
          otherData = data.map(item => {
            const feeObj = this.specialFeeList.find(e => e.code === item.feeTypeCode);
            return {
              ...item,
              specialRules: feeObj ? feeObj.specialRules : '',
              isISS: item.isISS === '1',
              isICMS: item.isICMS === '1',
              isISSn: item.isISSn === '1'
            };
          });

          // 赋值
          const feeTypeMap = {
            FY002: { price5: 'price' }, // 操作费
            FY005: { taxRate2: 'taxRate', price2: 'price' }, // 保险费
            FY006: { taxRate3: 'taxRate' }, // 风险管理费
            FY009: { weight1: 'weight', price7: 'price' }, // 托盘处理费
            FY011: { weight: 'weight', price6: 'price' }, // 超重处理费
            FY013: { taxRate: 'taxRate', price: 'price' }, // 从价税
            FY014: { taxRate1: 'taxRate', price1: 'price' }, // GRIS
            FY015: { weight2: 'weight', price8: 'price' }, // 过路费
            FY016: { price4: 'price' }, // 发行费
            FY020: { price3: 'price' }, // CT-e
            FY021: { weight: 'weight', price6: 'price' }, // 超重（kg）
            FY022: { weight2: 'weight', price8: 'price' }, // 仓库异常费
            FY023: { taxRate1: 'taxRate', price1: 'price' }, // GRIS2
            FY024: { taxRate: 'taxRate', price: 'price' }, // 从价税2
            FY025: { taxRate: 'taxRate', price: 'price' }, // 内河运输费
            FY028: { ruleType: 'ruleType', taxRate4: 'taxRate' }, // 运输保险费+比例
            FY029: { price9: 'price' }, // 装车费
            FY030: { price10: 'price' } // 卸车费
          };

          otherData.forEach(item => {
            const { feeTypeCode } = item;
            const mapping = feeTypeMap[feeTypeCode];
            console.log(mapping, 'mapping');
            if (mapping) {
              Object.keys(mapping).forEach(key => {
                console.log(key, 'key', mapping[key], item[key]);
                item[mapping[key]] = item[key];
              });
            } else {
              console.warn(`未知的 feeTypeCode: ${feeTypeCode}`);
            }
          });

          console.log('特殊规则数据', otherData);
        }
        const excelData = this.importType === 1 ? data : otherData;
        console.log(excelData, 'excelData');
        if (this.errData.length > 0) {
          this.dialogVisible = true;
        } else {
          this.$emit('importPartition', excelData, this.importType);
        }
      } catch (error) {
        console.log(error);
        this.$message.error(this.$t('orderCenterCont.ImportFailed'));
      }
    }
  }
};
</script>
